import React from 'react';
import * as Progress from '@radix-ui/react-progress';
import { CheckCircle2, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { useProgress } from '../hooks/useProgress';

interface ProgressIndicatorProps {
  sectionId: string;
}

export function ProgressIndicator({ sectionId }: ProgressIndicatorProps) {
  const { progress, getProgress } = useProgress();
  const sectionProgress = progress[sectionId];
  const progressValue = getProgress(sectionId);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {sectionProgress?.completed ? (
            <CheckCircle2 className="w-5 h-5 text-green-500" />
          ) : (
            <Clock className="w-5 h-5 text-blue-500" />
          )}
          <span className="text-sm font-medium">
            {sectionProgress?.completed ? 'Completed' : 'In Progress'}
          </span>
        </div>
        {sectionProgress?.lastVisited && (
          <span className="text-sm text-gray-500">
            Last visited {formatDistanceToNow(new Date(sectionProgress.lastVisited))} ago
          </span>
        )}
      </div>
      
      <Progress.Root
        className="relative overflow-hidden bg-gray-200 rounded-full w-full h-2"
        value={progressValue}
      >
        <Progress.Indicator
          className="bg-blue-500 w-full h-full transition-transform duration-500"
          style={{ transform: `translateX(-${100 - progressValue}%)` }}
        />
      </Progress.Root>
      
      {sectionProgress?.timeSpent && (
        <div className="text-sm text-gray-500">
          Time spent: {Math.round(sectionProgress.timeSpent / 60)} minutes
        </div>
      )}
    </div>
  );
}